import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import SEO from '../components/SEO';

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ username: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    setLoading(true); setError('');
    try {
      await login(form.username, form.password);
      navigate('/');
    } catch {
      setError('Invalid username or password.');
    } finally { setLoading(false); }
  };

  const inputStyle = { width: '100%', padding: '0.75rem 1rem', border: '1px solid #e5e5e5', borderRadius: 8, fontFamily: 'sans-serif', fontSize: '0.95rem', outline: 'none', marginBottom: '1rem' };

  return (
    <div style={{ minHeight: '80vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '2rem' }}>
      <SEO title="Sign In" description="Sign in to Pitch & Pen to read and write African football stories." noindex />
      <div style={{ width: '100%', maxWidth: 400 }}>
        <h1 style={{ fontSize: '1.75rem', marginBottom: '0.5rem', textAlign: 'center' }}>Welcome back</h1>
        <p style={{ textAlign: 'center', color: '#666', fontFamily: 'sans-serif', marginBottom: '2rem', fontSize: '0.9rem' }}>Sign in to Pitch & Pen</p>
        {error && <p style={{ background: '#fdecea', color: '#c0392b', padding: '0.75rem 1rem', borderRadius: 8, fontFamily: 'sans-serif', fontSize: '0.875rem', marginBottom: '1rem' }}>{error}</p>}
        <input value={form.username} onChange={e => setForm({ ...form, username: e.target.value })} placeholder="Username" style={inputStyle} />
        <input type="password" value={form.password} onChange={e => setForm({ ...form, password: e.target.value })} placeholder="Password" style={inputStyle}
          onKeyDown={e => e.key === 'Enter' && handleSubmit()} />
        <button onClick={handleSubmit} disabled={loading} className="btn btn-primary" style={{ width: '100%', padding: '0.75rem', fontFamily: 'sans-serif', fontSize: '0.95rem' }}>
          {loading ? 'Signing in…' : 'Sign in'}
        </button>
        <p style={{ textAlign: 'center', fontFamily: 'sans-serif', fontSize: '0.875rem', marginTop: '1.5rem', color: '#666' }}>
          Don't have an account? <Link to="/register" style={{ color: '#1a6b45' }}>Join Pitch & Pen</Link>
        </p>
      </div>
    </div>
  );
}
